import React from 'react';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import { empty, url } from '../../../../antd/form/FormValidation.js';
import FormSwitch from '../../../../antd/form/FormSwitch/FormSwitch.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import Form from '../../../../antd/form/Form/Form.jsx';

const UsefulLinkForm = ({ onSubmit, initials }) => {
  const { t } = useTranslation();

  return (
    <Form onFinish={onSubmit} initialValues={initials}>
      <FormTextField
        label={t('Názov (slovensky)')}
        name={'title'}
        rules={[empty(t)]}
      />

      <FormTextField label={t('Názov (anglicky)')} name={'title_en'} />

      <FormTextField
        label={t('URL v slovenskej verzii')}
        name={'url'}
        rules={[empty(t), url(t)]}
      />

      <FormTextField
        label={t('URL v anglickej verzii')}
        name={'url_en'}
        rules={[url(t)]}
      />

      <FormSwitch label={t('Zobrazená')} name={'visible'} />

      <FormSwitch label={t('Nová')} name={'new'} />

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'usefulLinks'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

export default UsefulLinkForm;
